import React, { Component } from 'react';
import { withStyles, Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import common from '~/common';

const styles = theme => ({
  text: { textAlign: 'start', marginLeft: 61, color: 'rgba(0, 0, 0, 0.54)', fontSize: 20, lineHeight: '24px' },
  line: { height: 1, backgroundColor: '#247690', marginLeft: 61, marginRight: 61 },
});

class App extends Component {
  componentDidMount () {
    document.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown=event => {
    if (event.keyCode === 13) this._check();
  }

  _check=() => {
    const { isManage } = this.props;
    if (isManage) this.props.history.push(`${common.rootPath}/Manage/Main`);
    else this.props.history.push(`${common.rootPath}/Gis`);
  }

  render () {
    const { classes, session = {} } = this.props;
    const { data = {} } = session;
    return (
      <div style={{ width: '100%', height: '100%', paddingTop: 52 }}>
        <div className={classes.text}>
          {`上次登入IP：${data.ip}`}
        </div>
        <div style={{ height: 2 }} />
        <div className={classes.line} />
        <div style={{ height: 31 }} />
        <div className={classes.text}>
          {`上次登入時間：${data.last_login_time}`}
        </div>
        <div style={{ height: 2 }} />
        <div className={classes.line} />
        <div style={{ height: 31 }} />
        <div className={classes.text}>
          {data.login_type === '0' && '上次登入狀態：'}
          {data.login_type === '1' && '上次登入狀態：登入成功'}
          {data.login_type === '2' && '上次登入狀態：登入失敗'}
        </div>
        <div style={{ height: 2 }} />
        <div className={classes.line} />
        <div style={{ height: 72, fontSize: 14, color: 'red', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {data?.need_change_pad ? '※密碼已六個月無變動，請更換!' : ''}
        </div>
        <Button style={{ width: 155, height: 47, borderRadius: 5, backgroundColor: '#247690', color: 'white', fontSize: 20 }} onClick={this._check}>
          確定
        </Button>

      </div>
    );
  }
}
const mapStateToProps = state => ({
  session: state.session,
  isManage: state.isManage,
});
const mapDispatchToProps = dispatch => ({
});
export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)));
